module.exports = __webpack_public_path__ + "img/cert_06.15f3bfe2.jpg";